import OTPScreen from "./otp";
import SigninScreen from "./signin";
import SignupScreen from "./signup";
import ForgetPasswordScreen from "./forget.password";
import ResetPasswordScreen from "./reset.password";

const routes = [
  {
    path: "/signin",
    component: SigninScreen,
  },
  {
    path: "/signup",
    component: SignupScreen,
  },
  {
    path: "/forget-password",
    component: ForgetPasswordScreen,
  },
  {
    path: "/verify",
    component: OTPScreen,
  },
  {
    path: "/reset-password",
    component: ResetPasswordScreen,
  },
];

export default routes;
